import React, { useState, useEffect } from "react";
import { Icon } from "@showitinc/showit-wc";
import styles from "./CountdownTimer.module.css";
import HelpConstants from "../../constants/HelpConstants";
import { calculateTimeLeft, getMostSignificantTime } from "../../utils/timeUtils";

const CountdownTimer = ({ targetDate, hasLaunched }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const updateTimer = () => {
      const { timeLeft: newTimeLeft } = calculateTimeLeft(targetDate);
      setTimeLeft(newTimeLeft);
    };

    // Run immediately
    updateTimer();

    // Set up interval
    const interval = setInterval(updateTimer, 1000);

    // Clean up
    return () => clearInterval(interval);
  }, [targetDate]);

  const significantTime = getMostSignificantTime(timeLeft);

  return (
    !hasLaunched && (
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.content}>
            <div className={styles.titleContainer}>
              <Icon type="publish" size="20" className={styles.clockIcon} />
              <span className={styles.title}>Launch Challenge</span>
            </div>

            <div className={styles.timerContainer}>
              <div className={styles.timeBox}>
                <div className={styles.timeValue}>{significantTime.value}</div>
                <div className={styles.timeLabel}>{significantTime.unit} Remaining</div>
              </div>
            </div>

            <div className={styles.helpIconContainer}>
              <a
                href={HelpConstants.LAUNCH_COUNTDOWN_TIMER}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.helpLink}
                aria-label="Help information about countdown timer"
                title="Learn more about the launch countdown timer"
              >
                <Icon type="help" size="16" className={styles.helpIcon} />
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default CountdownTimer;
